import request from './request.js';
import {requestbody} from './request.js'

export async function dsrw_query(params = {}) {
    return await requestbody('batch/taskPageInfo', 'post', params)
}

export async function dsrwxx_query(params = {}) {
    return await requestbody('batch/findAllTask', 'post', params)
}

export async function dsrw_save(params = {}) {
    return await requestbody('monitor/job/save', 'post', params)
}

export async function dsrw_update(params = {}) {
    return await requestbody('monitor/job/update', 'post', params)
}

export async function dsrwgl_query(params = {}) {
    return await request('monitor/job/page', 'get', params)
}